import { render, staticRenderFns } from "./add-maintain-order-modal.vue?vue&type=template&id=5a877e1a&"
import script from "./add-maintain-order-modal.vue?vue&type=script&lang=js&"
export * from "./add-maintain-order-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports